function isRtsp(url: string): boolean {
  const regex = new RegExp(/(rtsp):\/\//);
  return regex.test(url);
}

export default isRtsp;
